module.exports = __webpack_public_path__ + "public/static/img/bg-title-light-theme.db857bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-title-light-theme.svg
// module id = qgna
// module chunks = 1